import React from "react";
import ListView from "./list-view";

const SearchResultsContent = () => {
  return (
    <div className='search-results-content'>
      <ListView />
    </div>
  );
};

export default SearchResultsContent;
